define('ProductDetails.Compatibility.View', [
  'SCView',
  'product_details_compatibility.tpl',
  'underscore'
], function (
  SCViewComponent,
  template,
  _
) {
  'use strict';

  var SCView = SCViewComponent.SCView;

  function ProductDetailsCompatibilityView(options) {
    SCView.call(this);
    this.options = options || {};
    this.template = template;
  }

  ProductDetailsCompatibilityView.prototype = Object.create(SCView.prototype);
  ProductDetailsCompatibilityView.prototype.constructor = ProductDetailsCompatibilityView;

  ProductDetailsCompatibilityView.prototype.getContext = function getContext() {
    var raw = (this.options.model.item && this.options.model.item['custitem_uc_compatibility']) || '';
    var trimmed = raw.trim();
    var names = trimmed ? trimmed.split(',') : [];
    var items = [];

    _.each(names, function (name) {
      var trimmedName = name.trim();
      if (trimmedName) {
        items.push({ name: trimmedName });
      }
    });

    return {
      showCompatibility: items.length > 0,
      items: items
    };
  };

  return ProductDetailsCompatibilityView;
});
